import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Container,
  Typography,
} from "@mui/material";
import React from "react";
import { back, connected, eagle_icon } from "../../assets/images";
import CustomButton from "../CustomButton";
import { ChevronRightRounded } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const StayConnected = () => {
  const navigate = useNavigate();
  const involvedText = [
    {
      id: 1,
      text: "Live in a remote or overpopulate environment where schooling is hard to come by",
    },
    {
      id: 2,
      text: "Are otherwise unable to attend other schools because of high costs",
    },
    {
      id: 3,
      text: " Are interested in engaging with course material in a practical, discussion-based format",
    },
    {
      id: 4,
      text: "Have a desire to learn more about the world and further their relationship with Christ",
    },
  ];

  return (
    <Box sx={{ width: "100vw" }}>
      <Container
        sx={{
          height: { md: "50vh" },
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: { xs: "center", md: "space-between" },
          alignItems: "center",
          backgroundImage: `url(${back})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          py: { xs: 5, md: 2 },
        }}
      >
        <Box
          sx={{
            width: { xs: "100%", md: "45%" },
            mb: { xs: 5 },
          }}
        >
          <Typography variant="h7" sx={{ mb: "1rem" }}>
            Stay Connected
          </Typography>
          <Typography variant="h2" sx={{ width: "90%", mb: "1rem" }}>
            How to <span style={{ color: "#DB5430" }}>connect</span> with
            the <span style={{ color: "#DB5430" }}>Eagle team</span>
          </Typography>
          <Typography>
            Every month, the EAGLE team will be sharing updates about what we
            have been doing and the impact EAGLE is having in communities. If
            you want to journey with us and stay connected, join our news
            network or contact us directly
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "row" }}>
            <CustomButton
              sx={{ my: "1rem" }}
              onClick={() => navigate("/donate/give")}
            >
              <Typography>Join our team</Typography>
              <ChevronRightRounded />
            </CustomButton>
          </Box>
        </Box>

        {/* Get involved Points */}
        <Box
          sx={{
            width: { xs: "100%", md: "45%" },
            height: { xs: "50vh", md: "100%" },
            backgroundSize: "cover",
            backgroundImage: `url(${connected})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            borderRadius: 5,
          }}
        />
      </Container>
    </Box>
  );
};

export default StayConnected;
